import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api2 from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import { url } from "inspector";
import api from "../../../utils/Url";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
type Props = {};
const BrandMasterAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValuestime } = getISTDate();
  const [toaster, setToaster] = useState(false);
  const initialRowData = {
    activeClass: "",
    all: true,
    showExisting: true,
    isSuccess: true,
    message: "",
    srno: 0,
    eScarp: true,
    eScarpPrevValue: "",
    css: "",
    brandId: 0,
    brandname: "",
    brandshortname: "",
    brandCode: "",
    createdBy: "",
    updatedBy: "",
    createdOn: defaultValuestime,
    updatedOn: defaultValuestime
  };
  useEffect(() => {
  }, []);
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const formik = useFormik({
    initialValues: {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      "srno": 0,
      "eScarp": true,
      "eScarpPrevValue": "",
      "css": "",
      "brandId": 0,
      "brandname": "",
      "brandshortname": "",
      "brandCode": "",
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime,
    },

    validationSchema: Yup.object({
      brandname: Yup.string()
        .required(t("text.reqBrandName")),
        // .min(2, "Brand Name must be at least 2 characters")
        // .max(50, "Brand Name cannot exceed 50 characters"),
      brandCode: Yup.string()
        .required(t("text.reqBrandCode")),
        // .min(1, "Brand Code must be at least 1 character")
        // .max(10, "Brand Code cannot exceed 10 characters"),
      brandshortname: Yup.string()
        .required(t("text.requiredShortName"))
        // .min(2, "Short Name must be at least 2 characters")
        // .max(20, "Short Name cannot exceed 20 characters"),
    }),
    onSubmit: async (values) => {
      const response = await api.post(`Brand/AddUpdateBrandmaster`, values);
      if (response.data.isSuccess) {
        setToaster(false);
        toast.success(response.data.msg);
        navigate("/vehiclemanagement/brandmaster");
      } else {
        setToaster(true);
        toast.error(response.data.msg);
      }
    },
  });
  const back = useNavigate();
  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.BrandMasterAdd")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.BrandName")}
                  value={formik.values.brandname}
                  onChangeText={(text: string) => formik.setFieldValue("brandname", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.brandname && formik.errors.brandname ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.brandname}
                  </div>
                ) : null}
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.BrandName")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="brandname"
    id="brandname"
    value={formik.values.brandname}
    placeholder={t("text.BrandName")}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
  />
  {formik.touched.brandname && formik.errors.brandname ? (
    <div style={{ color: "red", margin: "5px" }}>
      {formik.errors.brandname}
    </div>
  ) : null}
</Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.BrandCode")} required={true} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="brandCode"
                  id="brandCode"
                  value={formik.values.brandCode}
                  placeholder={t("text.BrandCode")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.brandCode && formik.errors.brandCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.brandCode}
                  </div>
                ) : null}
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.ShortName")}
                  value={formik.values.brandshortname}
                  onChangeText={(text: string) => formik.setFieldValue("brandshortname", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.brandshortname && formik.errors.brandshortname ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.brandshortname}
                  </div>
                ) : null}
              </Grid> */}
              <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.ShortName")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="brandshortname"
    id="brandshortname"
    value={formik.values.brandshortname}
    placeholder={t("text.ShortName")}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
  />
  {formik.touched.brandshortname && formik.errors.brandshortname ? (
    <div style={{ color: "red", margin: "5px" }}>
      {formik.errors.brandshortname}
    </div>
  ) : null}
</Grid>


              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};
export default BrandMasterAdd;